import {
  axiosErr
} from '@/libs/utils';
export default {
  computed: {
    language() {
      return {
        'lang': this.$store && this.$store.state.admin.lang || ""
      }
    }
  },
  methods: {
    axiosErr(xhr, code) {
      /**
       * @param {Object} xhr  XMLHttpRequest
       * @param {number|string} code 状态码
       */
      return axiosErr(xhr, code, this)
    },
    showLang(name) {
      return this.$t(name)
    }
  }
};



// WEBPACK FOOTER //
// ./src/libs/mixin.js